import { render, staticRenderFns } from "./NodeCarousel.vue?vue&type=template&id=f8f95c3a&scoped=true&"
import script from "./NodeCarousel.vue?vue&type=script&lang=js&"
export * from "./NodeCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f95c3a",
  null
  
)

export default component.exports